import { Dispatch, SetStateAction, useRef, useState } from "react";
import { Popover, Whisper, WhisperInstance } from "rsuite";
import { flushSync } from "react-dom";
import { useAtomValue } from "jotai";
import { Button } from "reactstrap";

import DropdownOptionWithIcon from "../../../components/Menus/DropdownOptionWithIcon";
import DropdownMenuDivider from "../../../components/Menus/DropdownMenuDivider";
import { RecordFileCaptureProps } from "../GrowthDriveInterfaces";
import AppSpinner from "../../../elements/AppSpinner";
import IconButton from "../../../elements/IconButton";
import { IsMobileAtom } from "../../../App";

interface MobileScreenOptionsProps {
  onIndexFiles?: (setIndexing: Dispatch<SetStateAction<boolean>>) => void;
  handleRecordFileCapture: (payload: RecordFileCaptureProps) => void;
}

function MobileScreenOptions({
  onIndexFiles,
  handleRecordFileCapture,
}: MobileScreenOptionsProps) {
  const [camera, setCamera] = useState<"Photo" | "Video">("Photo");
  const mobileScreen = useAtomValue(IsMobileAtom);
  const [indexing, setIndexing] = useState(false);
  const cameraWhisperRef = useRef<WhisperInstance>(null);
  const cameraRef = useRef<HTMLInputElement>(null);

  return (
    <>
      {onIndexFiles && (
        <Button
          size="sm"
          color="secondary"
          onClick={() => onIndexFiles(setIndexing)}
          className="tw:ml-0 tw:mr-1"
          disabled={indexing}
        >
          {indexing ? (
            <>
              Indexing...
              <AppSpinner size="sm" className="ml-2" />
            </>
          ) : (
            "Index Files"
          )}
        </Button>
      )}
      {mobileScreen && (
        <>
          <input
            accept={`${camera === "Photo" ? "image/*" : "video/*"}`}
            style={{ display: "none" }}
            ref={cameraRef}
            type="file"
            capture="environment"
            onChange={(e) =>
              handleRecordFileCapture({ type: "Custom", target: e.target })
            }
          />
          <Whisper
            placement="autoVerticalStart"
            preventOverflow
            trigger="click"
            ref={cameraWhisperRef}
            speaker={
              <Popover className="sidebar-popover">
                <DropdownOptionWithIcon
                  name="Take Photo"
                  onClick={() => {
                    flushSync(() => setCamera("Photo"));

                    if (cameraRef?.current) cameraRef.current.click();
                    cameraWhisperRef?.current?.close();
                  }}
                  icon={`mdi mdi-camera-outline text-dark`}
                />
                <DropdownMenuDivider />
                <DropdownOptionWithIcon
                  name="Take Video"
                  onClick={() => {
                    flushSync(() => setCamera("Video"));

                    if (cameraRef?.current) cameraRef.current.click();
                    cameraWhisperRef?.current?.close();
                  }}
                  icon={`mdi mdi-video-outline text-dark`}
                />
              </Popover>
            }
          >
            <div className="mr-4">
              <IconButton
                color={"secondary"}
                outline={false}
                icon="mdi mdi-camera"
                onClick={undefined}
              />
            </div>
          </Whisper>{" "}
        </>
      )}
    </>
  );
}

export default MobileScreenOptions;
